import React from 'react';
import { Button, Dialog, TextField } from '../../../../components';
import { FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import { useCreateDefaultUser } from '../graphql/useCreateDefaultUser';
import styled from 'styled-components';

type CreateUserDialogProps = {
  open: boolean;
  onClose: (success?: boolean) => void;
};

export const CreateUserDialog: React.FC<CreateUserDialogProps> = (
  props: CreateUserDialogProps,
) => {
  const { open, onClose } = props;
  const createDefaultUser = useCreateDefaultUser();

  const handleCloseDialog = (result?: boolean): void => {
    onClose(result);
  };

  const handleSubmit = async (values: {
    netId: string;
    department?: string;
    displayName?: string;
    email?: string;
  }): Promise<void> => {
    const result = await createDefaultUser({
      variables: {
        input: {
          netId: values.netId,
          department: values.department,
          email: values.email,
        },
      },
    })
      .then(res => {
        return res?.data?.createDefaultAdvancedUser;
      })
      .catch(() => false);

    handleCloseDialog(result);
  };

  const formik = useFormik({
    validationSchema: yup.object().shape({
      netId: yup.string().required('NetID is required'),
    }),
    initialValues: {
      netId: '',
      department: '',
      displayName: '',
      email: '',
    },
    onSubmit: handleSubmit,
  });

  return (
    <Dialog
      dialogTitle="Create Default User"
      openDialog={open}
      onDialogClose={handleCloseDialog}
    >
      <div>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <TextFieldGroup>
              <TextField
                label="NetID"
                name="netId"
                value={formik.values.netId}
                onChange={formik.handleChange}
                required
                fullWidth
              />
              <TextField
                label="Department"
                name="department"
                value={formik.values.department}
                onChange={formik.handleChange}
                fullWidth
              />
              <TextField
                label="Display Name"
                name="displayName"
                value={formik.values.displayName}
                onChange={formik.handleChange}
                fullWidth
              />
              <TextField
                label="Email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                fullWidth
              />
            </TextFieldGroup>
            <ButtonGroup>
              <Button
                onClick={() => {
                  handleCloseDialog();
                }}
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained">
                Submit
              </Button>
            </ButtonGroup>
          </form>
        </FormikProvider>
      </div>
    </Dialog>
  );
};

const TextFieldGroup = styled.div`
  margin: 2rem;
`;
const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 2rem;
`;
